import React, { Component } from 'react';
import "./Photo.scss"
import "./Animation.scss"
import ScrollableAnchor from 'react-scrollable-anchor'
import VideoPopup from "../../Helpers/Popup/VideoPopup"
import { setScrollNaming } from '../../Services/ScrollURL';

class Photo extends Component {
  constructor() {
    super();
    this.state = {
      isActive: false
    }
  }
  componentDidMount() {
    setScrollNaming(this.section);
  }
  componentWillReceiveProps(nextProps) {
    window.setTimeout(() =>
      this.setState({
        isActive: nextProps.currentScreen == 3
      }), 500);
  }
  render() {
    return (
        <section className="section section-photo" ref={section => this.section = section}>
          <div className="padding">
            <div className="container">
              <div className="headline">
                <div className={`supercamera_anim ${this.state.isActive ? "active" : ""}`}></div>
              <div className="icon_desc">
                Super Bright Camera
              </div>
                <div className="head">
                  איך זה מרגיש
                </div>
                <div className="teaser">
                לצלם תמונה של פעם בחיים
                </div>
              </div>
            </div>
            <div className="playbutton" onClick={() => {
              this.props.togglePopup(<VideoPopup videoIndex={1} />, "VideoPopup")
            }}>
              <div className="play"></div>
            </div>
          </div>
        </section>
    );
  }
}

export default Photo;



// WEBPACK FOOTER //
// ./src/Components/Screens/3_Photo/Photo.jsx